import AxiosProvider from '../../providers/AxiosProvider'
import { ENABLE_CREDENTIALS_FOR_REQUEST } from '../../Constants'

export const requestOTP = async (phoneNumber, provider) => {
  const reqURL = '/otp/new'
  const beepAxios = AxiosProvider.getBeepAxios()
  const response = await beepAxios
    .post(reqURL, {
      number: phoneNumber,
      provider
    })
    .catch((errorResp) => Promise.reject(errorResp.response.data))
  return response.data
}

export const verifyOTP = async (body) => {
  const { otp, hashPass } = body
  const reqURL = '/otp/verify'
  const beepAxios = AxiosProvider.getBeepAxios()
  const response = await beepAxios
    .post(reqURL, {
      otp,
      hashPass
    })
    .catch((errorResp) => Promise.reject(errorResp.response.data))
  return response.data
}

export const getNumbers = async (token) => {
  const reqURL = '/otp/numbers'
  const beepAxios = AxiosProvider.getBeepAxios()
  const response = await beepAxios
    .get(reqURL, {
      headers: {
        Authorization: token
      }
    })
    .catch((errorResp) => Promise.reject(errorResp.response.data))
  return response.data
}

export const logout = async (token) => {
  const reqURL = '/otp/logout'
  const beepAxios = AxiosProvider.getBeepAxios()
  const response = await beepAxios
    .delete(reqURL, {
      withCredentials: ENABLE_CREDENTIALS_FOR_REQUEST
    })
    .catch((errorResp) => Promise.reject(errorResp.response.data))
  return response.data
}

export const verifyPassword = async (password) => {
  const reqURL = '/auth/verify'
  const beepAxios = AxiosProvider.getBeepAxios()
  const response = await beepAxios
    .post(reqURL, {
      password
    })
    .catch((errorResp) => {
      throw new Error(errorResp.response.data.message)
    })
  return response.data
}
